<template>
  <section>
    <div class="personal-center-form__section">
      <h1 class="personal-center-form__title">银行卡签约</h1>
      <div class="personal-center-form__main">
        <el-row :gutter="0" class="personal-center-form__form" style="padding-bottom:0;">
          <el-col :span="16">
            <el-form :label-width="'50%'" :model="realAuthFormModel" :rules="rules" ref="realAuthForm">
              <el-form-item label="银行卡号" prop="bankcardNum">
                <el-input v-model="bankAccountNum" readonly :disabled="isEditable"></el-input>
              </el-form-item>
              <el-form-item label="银行预留手机号" prop="mobile">
                <el-input placeholder="请输入手机号" v-model="realAuthFormModel.mobile" :maxlength="11"
                          ></el-input>
              </el-form-item>
              <el-form-item label="姓名" prop="name">
                <el-input placeholder="请输入姓名" v-model="realAuthFormModel.name" :disabled="isEditable"></el-input>
              </el-form-item>
              <el-form-item label="身份证号码" prop="idno">
                <el-input placeholder="请输入身份证号码" v-model="realAuthFormModel.idno" :disabled="isEditable"
                          :maxlength="IDMaxLength"></el-input>
              </el-form-item>
              <!--<el-form-item label="签约号码" prop="proNumber">-->
                <!--<el-input placeholder="请输入您的签约号" v-model="realAuthFormModel.proNumber" :maxlength="16"></el-input>-->
              <!--</el-form-item>-->
              <el-form-item label="短信验证码" prop="SMSCode" class="SMS-cont">
                <el-input placeholder="请输入短信验证码"   :disabled="SMSCodeBtn.isEditabe" v-model="realAuthFormModel.SMSCode"></el-input>
                <el-button  :disabled="SMSCodeBtn.btnState" type="primary" size="mini" class="el-button-sms-code" @click.stop="getSMSCode">
                  {{SMSCodeBtn.text}}
                </el-button>
              </el-form-item>
            </el-form>
          </el-col>
        </el-row>
        <div class="tips_info el-icon-information">如有信息出错，请联系管理员修改</div>
        <div class="text-center">
          <el-button type="primary" :loading="isSaving" class="personal-center-form__submit" :disabled="isSubmit"
                     @click="submitForm">提交
          </el-button>
          <el-button type="primary" class="personal-center-form__submit" @click="backBankCardInfo">返回</el-button>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
  import api from '../../vuex/api'
  import _ from 'lodash'
  import { mapGetters, mapActions, mapMutations } from 'vuex'
  import * as types from '../../vuex/types'

  export default {
    data () {
      const assignValidator = (type, trigger = 'blur') => Object.assign({
        required: true,
        trigger
      }, {
        validator: (rules, value, callback, source, options) => {
          this.$store.dispatch(type, {rules, value, callback, source, options})
        }
      })
      return {
        indexCode: '',
        IDMaxLength: 18,
        isEditable: true,
        isSaving: false,
        bankAccountNum: '',
        isSubmit: false,
        rules: {
          bankCardNum: [assignValidator(types.VERIFY_BANKCARD_NUM)],
          mobile: [assignValidator(types.VERIFY_CELLPHONE)],
          name: [assignValidator((types.VERIFY_CHN_NAME))],
          idno: [assignValidator(types.VERIFY_ID_CARD_NUM)],
          SMSCode: [
            {
              required: true,
              trigger: 'blur',
              validator (rule, value, callback) {
                if (_.trim(value) === '') {
                  callback(new Error('请输入收到的短信验证码'))
                }
                callback()
              }

            }
          ]
          // proNumber: [
          //   {
          //     required: true,
          //     trigger: 'blur',
          //     validator (rule, value, callback) {
          //       if (_.trim(value) === '') {
          //         callback(new Error('签约号不能为空'))
          //       }
          //       callback()
          //     }
          //   }
          // ]
        },
        SMSCodeBtn: {
          btnState: false,
          isEditable: true,
          text: '获取验证码'
        }
      }
    },
    computed: {
      ...mapGetters({
        myInfo: types.GET_MY_INFO,
        userInfo: types.GET_USER,
        realAuthFormModel: types.GET_REAL_NAME_AUTH_ALL_INFO,
        bankList: types.GET_BANK_LIST,
        stateCode: types.GET_REAL_NAME_STATE
      })
    },
    methods: {
      ...mapMutations({
        setRealNameAuthInfo: types.SET_REAL_NAME_AUTH_ALL_INFO,
        setBankList: types.SET_BANK_LIST,
        updateBankCardNum: types.UPDATE_BANK_CARD_NUM,
        setRealNameState: types.SET_REAL_NAME_STATE
      }),
      ...mapActions({
        getRealNameAuthData: types.GET_REAL_NAME_AUTH_DATA,
        setSuccessMessage: types.SET_SUCCESS_MESSAGE,
        setFailMessage: types.SET_FAIL_MESSAGE
      }),
      submitForm () {
        this.$refs.realAuthForm.validate((valid) => {
          if (valid) {
            this.loading = true
            api.authPersonSignAgreement({
              //proNumber: this.realAuthFormModel.proNumber,
              bankAccount: this.bankAccountNum,
              // bankAccount: this.$route.params.bankAccountName,
              bankAccountOwner: this.realAuthFormModel.name,
              mobile: this.realAuthFormModel.mobile,
              idno: this.realAuthFormModel.idno,
              customerId: this.userInfo.crmCustomerId,
              vCode: this.realAuthFormModel.SMSCode,
              token: this.userInfo.token,
              indexCode: this.indexCode
            }).then((res) => {
              if (Number(res.data.code) === 0) {
                this.loading = false
                this.setSuccessMessage({
                  show: true,
                  content: res.data.result
                })
                this.isSubmit = true
				this.$router.push({path: `/personalCenter/bankcardInfo`})                
              } else {
                this.setFailMessage({
                  show: true,
                  content: res.data.result
                })
              }
            }).catch((res) => {
              this.loading = false
            })
          } else {
            return false
          }
        })
      },
      gotoLoan () {
        const that = this
        this.$alert('请先申请贷款，审批通过后再进行实名认证！', ' ', {
          confirmButtonText: '确定',
          type: 'warning',
          beforeClose: (action, instance, done) => {
            that.$router.push({path: '/personalCenter/myLoan'})
            done()
          }
        })
      },
      selectCardNO (curr) {
        this.updateBankCardNum(curr)
      },
      getSMSCode () {
        // 由于签约号规则还没有确定
        /* this.$refs.realAuthForm.validateField('mobile')
         this.$refs.realAuthForm.validateField('name')
         this.$refs.realAuthForm.validateField('idno')
         this.$refs.realAuthForm.validateField('proNumber')*/
        api.authPersonSMSCode({
          token: this.userInfo.token,
          customerId: this.userInfo.crmCustomerId,
          proNumber: this.realAuthFormModel.proNumber,
          mobile: this.realAuthFormModel.mobile,
          msgType: 0,
          bankAccount: this.bankAccountNum,
          bankAccountOwner: this.realAuthFormModel.name,
          idno: this.realAuthFormModel.idno
        }).then((res) => {
          const resData = res.data
          this.indexCode = resData.data
          let countDownTime = 60;

          if (Number(resData.code) === 0) {
            this.SMSCodeBtn = {
              btnState: true,
              isEditable: false,
              text: `${countDownTime}秒后获取`
            }
            const countDown = setInterval(() => {
              countDownTime -= 1
              if (countDownTime !== 0) {
                this.SMSCodeBtn['text'] = `${countDownTime}秒后获取`
              } else {
                this.SMSCodeBtn = {
                  btnState: false,
                  isEditable: false,
                  text: '重新获取验证码'
                }
                clearInterval(countDown)
              }
            }, 1000)
          } else {
            this.setFailMessage({
              show: true,
              content: resData.result
            })
          }
        })

      },
      backBankCardInfo () {
        this.$router.push({path: 'bankcardInfo'})
      }
    },
    mounted () {
      this.bankAccountNum = this.$route.params.bankAccountName
      this.getRealNameAuthData({
        token: this.userInfo.token,
        crmCustomerType:this.userInfo.crmCustomerType
      }).then((res) => {
        const data = res.data
        this.setRealNameState(Number(data.code))
        if (Number(data.code) === 0 || Number(data.code) === 3) {
          this.setRealNameAuthInfo(res.data.result)
          this.setBankList(res.data.result.bankList)
          if (Number(data.result.bankAccountIsAuthentication) === 1) {
            this.updateBankCardNum(data.result.bankAccountName)
          }
        } else {
          this.gotoLoan()
        }
      })
    }
  }
</script>
<style lang="scss">
  .personal-center-form__alreadyAuth {
    margin-bottom: 25px;
    height: 40px;
    background: $lightWaterBlue;
  }

  .personal-center-form__alreadyAuth.is-disabled, .personal-center-form__alreadyAuth.is-disabled:hover {
    color: #fff;
    background-color: #c6c6c6;
  }

  //短信验证码
  .SMS-cont {
    position: relative;

    .el-button-sms-code {
      background: #00C0FF;
      position: absolute;
      right: 7px;
      top: 7px;
    }

    .el-button-sms-code.is-disabled {
      background: #DCDCDC;
    }
  }
</style>



// WEBPACK FOOTER //
// bankCardSign.vue?66bb7d69